/** True when the Storyblok Visual Editor (or draft preview) is active for this navigation. */
export function isStoryblokPreviewSearch(searchParams: URLSearchParams): boolean {
  return Boolean(searchParams.get('_storyblok_tk') || searchParams.get('_storyblok'))
}
